module.exports = __webpack_public_path__ + "media/message 3.03d3f54c.mp3";